require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-planning-target-audience-research.json") })
        }
      }, "path---services-planning-target-audience-research");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-planning-target-audience-research!./.cache/json/services-planning-target-audience-research.json
// module id = 777
// module chunks = 231608221292675